export default function Logo() {
  return <img src="../logo.png" alt="" className="m-logo" />
}
